import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './navbar.css';

function Navbar() {
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleDropdown = (menu) => {
    setOpenDropdown(prev => (prev === menu ? null : menu));
  };

  return (
    <nav className="navbar">
      <div className="container">
        <Link to="/" className="logo">Orbit Energy</Link>
        <ul className="nav-links">
          <li><Link to="/">Home</Link></li>

          {/* <li 
            className={`dropdown ${openDropdown === 'services' ? 'open' : ''}`} 
            onClick={() => handleDropdown('services')}
          >
            <span className="dropbtn">Services</span>
            <div className="dropdown-content">
              <Link to="/services/electricity">Business Electricity</Link>
              <Link to="/services/gas">Business Gas</Link>
              <Link to="/services/merchant">Business Energy</Link>
            </div>
          </li> */}

          {/* <li 
            className={`dropdown ${openDropdown === 'about' ? 'open' : ''}`} 
            onClick={() => handleDropdown('about')}
          >
            <span className="dropbtn">About</span>
            <div className="dropdown-content">
              <Link to="/services/electricity">About Us</Link>
              <Link to="/services/gas">Our Suppliers</Link>
              <Link to="/services/merchant">Our Sectors</Link>
            </div>
          </li> */}
          <li><Link to="/Contacts">Contacts</Link></li>
          <li><Link to="/Complains">Complaints Procedure</Link></li>
        </ul>
        <div className="nav-buttons">
          {/* <Link to="/login" className="btn">Login</Link>
          <Link to="/register" className="btn btn-primary">Register</Link> */}
          </div>
      </div>
    </nav>
  );
}

export default Navbar;
